import * as React from 'react';
import { SelectionState } from '../components/CustomSelection/SelectionStream';
import { Contents, Section } from '../types/epubs';
import { TextSelectionContext } from './TextSelection';

interface ITextSelectionProviderProps {
  children?: React.ReactNode;
}

const TextSelectionProvider: React.FunctionComponent<
  ITextSelectionProviderProps
> = (props) => {
  const [pageNumber, setPageNumber] = React.useState<number>(0);
  const [containerElement, setContainerElement] =
    React.useState<HTMLDivElement>(undefined);
  const [epubSection, setEpubSection] = React.useState<Section>();
  const [epubContents, setEpubContents] = React.useState<Contents>();
  const [selectionState, setSelectionState] = React.useState<SelectionState>();
  const [customTextSelection, setCustomTextSelection] =
    React.useState<boolean>(false);

  return (
    <TextSelectionContext.Provider
      value={{
        selectionState,
        setSelectionState,
        pageNumber,
        setPageNumber,
        epubSection,
        setEpubSection,
        epubContents,
        setEpubContents,
        containerElement,
        setContainerElement,
        customTextSelection,
        setCustomTextSelection,
      }}
    >
      {props.children}
    </TextSelectionContext.Provider>
  );
};

export default TextSelectionProvider;
